import { Button, DatePicker, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DATE_FORMATS } from 'utils/date';

import {
  OfferBannerFilterFormField,
  OfferBannerFilterFormValues,
} from './type';

const { useBreakpoint } = Grid;

type UsersWithWalletFilterFormProps = {
  formId: string;
  handleFilter: (values: OfferBannerFilterFormValues) => void;
  initialValues: OfferBannerFilterFormValues;
  closeModal?: () => void;
  form: any;
};

export const OfferBannerFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
  form,
}: UsersWithWalletFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  // const [form] = Form.useForm<OfferBannerFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const { RangePicker } = DatePicker;

  const onReset = () => {
    form.resetFields();
    handleFilter({ ...initialValues });
  };

  const handleOnFinish = (values: OfferBannerFilterFormValues) => {
    handleFilter(values);
    // setQueryFilters(values);
    closeModal?.();
  };

  return (
    <>
      <div className='notify_form'>
        <Form<OfferBannerFilterFormValues>
          id={formId}
          name={formId}
          form={form}
          layout='vertical'
          onFinish={handleOnFinish}
          initialValues={initialValues}
          onFinishFailed={() => {
            setValidateTrigger(['onChange']);
          }}
          validateTrigger={validateTrigger}
        >
          <ContentFilters.FormItemsWrapper>
            <StandardItemsWrapper>
              <Form.Item<OfferBannerFilterFormValues>
                label={'Title'}
                name={OfferBannerFilterFormField.title}
              >
                <Input placeholder='Search By the discount code and facility name' />
              </Form.Item>

              <Form.Item<OfferBannerFilterFormValues>
                label={'Date'}
                name={OfferBannerFilterFormField.Date}
              >
                <RangePicker
                  allowEmpty={[true, true]}
                  format={DATE_FORMATS.date}
                />
              </Form.Item>

              <Form.Item<OfferBannerFilterFormValues>
                label={'Status'}
                name={OfferBannerFilterFormField.status}
              >
                <Select
                  style={{ width: 120 }}
                  options={[
                    { value: true, label: 'Active' },
                    { value: false, label: 'InActive' },
                    // { value: '3', label: 'Expired' },
                  ]}
                  placeholder='Select Status'
                />
              </Form.Item>
            </StandardItemsWrapper>
          </ContentFilters.FormItemsWrapper>

          {screens.lg && (
            <ContentFilters.ButtonsWrapper>
              <Button type='primary' htmlType='submit'>
                {t('wallet.buttons.filter', { count: 1 })}
              </Button>
              <Button onClick={onReset}>{t('wallet.buttons.reset')}</Button>
            </ContentFilters.ButtonsWrapper>
          )}
        </Form>
      </div>
    </>
  );
};
